










import Vue from 'vue';

export interface Param {
  display: string;
  /**
   * Actions on Google do NOT require name (eg for YesNo or simple response)
   * AWS Lex DOES require
   */
  name?: string;
  /**
   * AWS Lex does not require `slotType`.
   * Dialogflow requires parameters[i].dataType if parameter value is required.
   * Actions on Google require this, but can be "$org.schema.type.Text"
   */
  entity?: string;
  value?: string;
  color?: string;
  background?: string;
  /** used to join words and parameters into a string */
  toString?: () => string;
}

/*
export class Param {
  constructor(public display: string,
              public name?: string,
              public entity?: string,
              public value?: string,
              public color?: string,
              public background?: string) {}

  public toString() {
    return this.display;
  }
}
*/

export default Vue.extend({
  // name: 'intent-parameter',
  props: {
    param: Object as () => Param
  },
  // props: ['param'],
  computed: {
    style(): {} {
      return {
        color: this.param.color,
        background: this.param.background
      };
    },
    avatar(): string {
      return this.param.entity ? this.param.entity.substr(0, 4) : 'E';
    },
    title(): string {
      let title = (this.param.entity || 'Entity')  + ': ' + this.param.name;
      if (this.param.value) {
        title += ' = ' + this.param.value;
      }
      return title;
    }
  }
});
